import { useMemo } from 'react';
import moment, { type Moment } from 'moment-timezone';
import { useSelector } from 'react-redux';
import { allDimensionsListSelector } from '@store/common/dimensionList/selectors';
import { MAX_INTERVAL, validateInterval } from './utils';
import { intervalSelector } from '@src/store/common/selectors';

function startOfMinute(date: Date | number | Moment) {
  return moment(date).startOf('minute').valueOf();
}

function getInterval(
  interval: { from: Date | number | Moment; to: Date | number | Moment },
  live: boolean,
) {
  if (live) {
    return interval;
  }
  return {
    ...interval,
    from: startOfMinute(interval.from),
    to: startOfMinute(interval.to),
  };
}

// const dimensions = [
//   'network_request_response_code',
//   'network_request_url_host',
//   'network_request_url_path',
// ];

const ONE_DAY = 86400;

function getMessage(validDimension: boolean, validInterval: boolean) {
  if (!validDimension) {
    return 'Dimension is not available';
  }
  if (!validInterval) {
    const max =
      MAX_INTERVAL > ONE_DAY
        ? `${Math.round(MAX_INTERVAL / ONE_DAY)} days`
        : `${Math.round(MAX_INTERVAL / 3600)} hours`;
    return `Widget is not available for more than ${max}, Please select a date and time accordingly.`;
  }
  return '';
}

export function useValidateParams({ dimensions = [] }) {
  const interval = useSelector(intervalSelector);
  const allDimensionList: any[] = useSelector(allDimensionsListSelector);


  const isIntervalValid = validateInterval(interval);
  const isDimensionValid = dimensions.every((dimension) =>
    allDimensionList.find((d) => d.field === dimension),
  );

  return {
    isIntervalValid,
    isDimensionValid,
    message: getMessage(isDimensionValid, isIntervalValid),
  };
}
